export enum ServiceOrderStatus {
  IN_PROGRESS = "IN_PROGRESS",
  DEFINE_WORK_SCOPE = "DEFINE_WORK_SCOPE",
  VALIDATE_WORK_SCOPE = "VALIDATE_WORK_SCOPE",
  FIX_WORK_SCOPE = "FIX_WORK_SCOPE",
  SENT = "SENT",
  CONFIRM = "CONFIRM",
  COMPLETED =  "COMPLETED",
  TO_FIX = "TO_FIX",
  CLOSED = "CLOSED",
  UNDER_EVALUATION = "UNDER_EVALUATION"
}
